"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneLinkParamsDelegate = void 0;
class OneLinkParamsDelegate {
    constructor(oneLink) {
        this.ampExtra = {
            setExtra: (key, value) => {
                const old = JSON.parse(this._oneLink.searchParams.get('amp_extra') || '{}');
                old[key] = value;
                this._oneLink.searchParams.set('amp_extra', JSON.stringify(old));
            },
            setExtras: (extras) => {
                const old = JSON.parse(this._oneLink.searchParams.get('amp_extra') || '{}');
                Object.keys(extras).forEach((key) => {
                    old[key] = extras[key];
                });
                this._oneLink.searchParams.set('amp_extra', JSON.stringify(old));
            },
            getExtra: (key) => {
                const old = JSON.parse(this._oneLink.searchParams.get('amp_extra') || '{}');
                return old[key];
            },
            hasExtra: (key) => {
                const old = JSON.parse(this._oneLink.searchParams.get('amp_extra') || '{}');
                return key in old;
            },
            removeExtra: (key) => {
                const old = JSON.parse(this._oneLink.searchParams.get('amp_extra') || '{}');
                delete old[key];
                this._oneLink.searchParams.set('amp_extra', JSON.stringify(old));
            },
        };
        this._oneLink = oneLink;
    }
    get pid() {
        return this._oneLink.searchParams.get('pid');
    }
    set pid(value) {
        if (value) {
            this._oneLink.searchParams.set('pid', value);
        }
    }
    get campaign() {
        return this._oneLink.searchParams.get('c');
    }
    set campaign(value) {
        if (value) {
            this._oneLink.searchParams.set('c', value);
        }
    }
    get deepLink() {
        return this._oneLink.searchParams.get('af_dp');
    }
    set deepLink(value) {
        if (value) {
            this._oneLink.searchParams.set('af_dp', value);
        }
    }
    get webDeepLink() {
        return this._oneLink.searchParams.get('af_web_dp');
    }
    set webDeepLink(value) {
        if (value) {
            this._oneLink.searchParams.set('af_web_dp', value);
        }
    }
    get deepLinkValue() {
        const res = this._oneLink.searchParams.get('deep_link_value');
        if (res) {
            return JSON.parse(res);
        }
        return null;
    }
    set deepLinkValue(value) {
        if (value) {
            this._oneLink.searchParams.set('deep_link_value', JSON.stringify(value));
        }
    }
    get forceDeepLink() {
        return this._oneLink.searchParams.get('af_force_deeplink') === 'true';
    }
    set forceDeepLink(value) {
        this._oneLink.searchParams.set('af_force_deeplink', value ? 'true' : 'false');
    }
    get abVersions() {
        return this._oneLink.searchParams.get('ab_version');
    }
    set abVersions(value) {
        if (value) {
            this._oneLink.searchParams.set('ab_version', value);
        }
    }
}
exports.OneLinkParamsDelegate = OneLinkParamsDelegate;
